import Page from '../../layout/Page'
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from '@material-ui/core'
import {
  AccessTime as TimeIcon,
  Assignment as AssignmentIcon,
  BarChart as BarChartIcon,
  Business as BusinessIcon,
  DeleteSweep as DeleteSweepIcon,
  LocalHospital as HospitalIcon,
  LocationOn as LocationIcon,
  People as PeopleIcon,
  Person as PersonIcon,
  Timeline as TimelineIcon
} from '@material-ui/icons'

const AdminToolsContent = (): JSX.Element => {
  return (
    <>
      <h1>Experimental Admin Tools</h1>
      <p>
        ⚠️ Note: to enable rapid development, these pages are not translated to
        Dutch and not styled. It is only recommended for advanced users.
      </p>
      <Box style={{ maxWidth: 600, marginTop: '3rem' }}>
        <Typography variant="h6" style={{ marginBottom: 16 }}>
          Organization Management
        </Typography>
        <List>
          <ListItem button component="a" href="/userlist">
            <ListItemIcon>
              <PeopleIcon />
            </ListItemIcon>
            <ListItemText primary="User List" />
          </ListItem>

          <ListItem button component="a" href="/practicelist">
            <ListItemIcon>
              <BusinessIcon />
            </ListItemIcon>
            <ListItemText primary="Practice List" />
          </ListItem>
          <ListItem button component="a" href="/locationlist">
            <ListItemIcon>
              <LocationIcon />
            </ListItemIcon>
            <ListItemText primary="Location List" />
          </ListItem>
          <ListItem button component="a" href="/psychologistlist">
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText primary="Psychologist List" />
          </ListItem>
          <ListItem button component="a" href="/insurerlist">
            <ListItemIcon>
              <HospitalIcon />
            </ListItemIcon>
            <ListItemText primary="Insurer List" />
          </ListItem>
        </List>

        <Typography variant="h6" style={{ marginBottom: 16, marginTop: 24 }}>
          Statistics & Reports
        </Typography>
        <List>
          <ListItem button component="a" href="/treatmentprogramlist">
            <ListItemIcon>
              <AssignmentIcon />
            </ListItemIcon>
            <ListItemText primary="Treatment Program List" />
          </ListItem>
          <ListItem button component="a" href="/time-registration-stats">
            <ListItemIcon>
              <TimeIcon />
            </ListItemIcon>
            <ListItemText primary="Time Registration Statistics (Consultation Price Codes)" />
          </ListItem>
          <ListItem button component="a" href="/registered-activities">
            <ListItemIcon>
              <TimelineIcon />
            </ListItemIcon>
            <ListItemText primary="Registered Activities (entry by entry)" />
          </ListItem>
          <ListItem button component="a" href="/aggregated-activities">
            <ListItemIcon>
              <BarChartIcon />
            </ListItemIcon>
            <ListItemText primary="Daily Activity Summary" />
          </ListItem>
          <ListItem button component="a" href="/average-hours">
            <ListItemIcon>
              <TimeIcon />
            </ListItemIcon>
            <ListItemText primary="Average Hours Per Day" />
          </ListItem>
        </List>

        <Typography variant="h6" style={{ marginBottom: 16, marginTop: 24 }}>
          Data Retention
        </Typography>
        <List>
          <ListItem button component="a" href="/dossier-cleanup">
            <ListItemIcon>
              <DeleteSweepIcon />
            </ListItemIcon>
            <ListItemText
              primary="Dossier Cleanup"
              secondary="Patient cards (60d) and files (90d) flagged for deletion — review, restore or remove"
            />
          </ListItem>
        </List>
      </Box>
    </>
  )
}

const AdminToolsPage = (): JSX.Element => {
  return <Page content={AdminToolsContent} menu={false} hideMenu />
}

export default AdminToolsPage
